import { FilledInput } from '@material-ui/core';

import styled, { css } from 'styled-components';

export const StyledFilledInput = styled(FilledInput)<{
  height?: string;
  pad?: string;
  readOnly?: boolean;
  topRightRadius?: string;
  bottomRightRadius?: string;
  topLeftRadius?: string;
  bottomLeftRadius?: string;
}>`
  background: #fff;
  border: 1px solid #d5d7db;

  height: ${props => props.height};
  font-weight: regular;
  border-top-right-radius: ${p => p.topRightRadius || '0.625rem'};
  border-bottom-right-radius: ${p => p.bottomRightRadius || '0.625rem'};
  border-top-left-radius: ${p => p.topLeftRadius || '0.625rem'};
  border-bottom-left-radius: ${p => p.bottomLeftRadius || '0.625rem'};

  .MuiFilledInput-input {
    padding: 0.875rem !important;
    border-top-right-radius: ${p => p.topRightRadius || '0.625rem'};
    border-bottom-right-radius: ${p => p.bottomRightRadius || '0.625rem'};
    border-top-left-radius: ${p => p.topLeftRadius || '0.625rem'};
    border-bottom-left-radius: ${p => p.bottomLeftRadius || '0.625rem'};
    border: ${p => p.error && '1px solid #D74545'};
    color: #454545;
    font-weight: regular;
  }

  /* .MuiFilledInput-adornedEnd {
    padding-right: 0;
  } */

  ${props =>
    props.readOnly &&
    css`
      &:hover,
      &:focus-within {
        background-color: #fff;
        cursor: pointer;
      }
    `}
`;
